<!-- 轮播测试 -->
<template>
  <div class="son-swiper">
    <swiper class="swiper-wrapper swiper-wrapper-n" :options="swiperOption">
      <swiper-slide class="swiper-slide" v-viewer="{inline:false,tooltip:false,movable:false,title:false,navbar:false}" v-for="(item, index) in resources" :key="index">
        <iframe class="son-iframe" v-if="item.link" :src="item.link"></iframe>
        <img class="logo" v-else  :src="jpg?`${item.img}.jpg`:`${item.img}.JPG`" @error="getJPG()" />


      </swiper-slide>
      <div class="swiper-pagination" v-for="(item,index) in resources" :key="index" slot="pagination"></div>
    </swiper>
    <div class="bt-button">
      <span v-if="activeItem.audio" class="audio" @click="playAudio(activeItem)"><img
          :src='audio?require("@/assets/img/audio-on.png"):require("@/assets/img/audio-off.png")' alt=""></span>
      <span v-if="activeItem.link" class="full-btn" @click="fullScreen(activeItem)"><img src="@/assets/img/full-btn.png"
          alt=""></span>
    </div>

  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  /* import browser from "@/utils/browser.js"; */

  import {
    Swiper,
    SwiperSlide,
    directive
  } from "vue-awesome-swiper";
  import "swiper/css/swiper.css";
  
  /* import slide from '@/components/slide' */

  export default {
    props: {
      id: {
        type: String
      }

    },
    //import引入的组件需要注入到对象中才能使用

    components: {
      Swiper,
      SwiperSlide,
    },
    directives: {
      swiper: directive,
    },
    data() {
      //这里存放数据
      return {
        activeId: this.id,
        activeIdx: 0,
        activeItem: {},
        resources: [],
        full: false,
        jpg: true,
        show: true,
        iframeLink: '',
        audio: this.$store.state.audio
      };
    },
    //监听属性 类似于data概念
    computed: {

      swiperOption() {
        if (this.resources.length == 1) {
          return {
            pagination: {
              el: ''
            }
          }
        } else return {
          autoplay: false,
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true
            /* 
                        progressbarOpposite: true, //使进度条分页器与Swiper的direction参数相反
                        bulletElement: "li", //设定分页器指示器（小点）的HTML标签。
                        dynamicBullets: true, //动态分页器，当你的slide很多时，开启后，分页器小点的数量会部分隐藏。
                        dynamicMainBullets: 2, //动态分页器的主指示点的数量
                        hideOnClick: true, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
                        clickable: true //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。 */
          },
        };
      },
    },
    //监控data中的数据变化
    watch: {
      id: {
        handler(newValue) {
          this.activeId = newValue;
          this.resources = [];
          this.show = false;

          this.getList(this.activeId);
          this.show = true;

        },
        deep: true
      },
      '$store.state.audio'() {
       
          this.audio = this.$store.state.audio;

      }
    },
    //方法集合
    methods: {
      playAudio() {
        console.log(this.$audio);
        if (!this.$audio.paused) {
          this.$audio.pause();
          this.audio = false;
           
        } else {
          this.$audio.play();
          this.audio = true;
        }
        this.$store.commit('changeAudio', this.audio);
      },
      imageIsExist(url) {
        return new Promise((resolve) => {
          var img = new Image();
          img.onload = function () {
            if (this.complete == true) {
              resolve(true);
              img = null;
            }
          }
          img.onerror = function () {
            resolve(false);
            img = null;
          }
          img.src = url;
        })
      },
      getJPG() {
        this.jpg = !this.jpg;
      },
      async getList(activeId) {
        let res = await this.$http({
          method: "get",
          url: `data.json`
        });
        this.list = res.list;
        this.list.forEach((item, i) => {
          if (item.id == activeId) {
            this.activeIdx = i;
            this.activeItem = item;
            if (this.activeItem.audiosrc) {
              console.log(this.activeItem.audiosrc)
              this.$audio.src = `${this.$cdn}audio/${this.activeItem.audiosrc}.mp3`;
            } else {
              this.$audio.src = `${this.$cdn}audio/${this.activeItem.id}.mp3`
            }

            if (this.activeItem.images > 0) {
              for (var j = 0; j < this.activeItem.images; j++) {
                this.resources.push({
                  img: this.$cdn + 'images/' + activeId + '/' + (j + 1)
                })
              }
            } else {
              this.resources.push({
                link: this.activeItem.link
              });
              this.iframeLink = this.activeItem.link
            }

            console.log(this.resources)
          }
        })
      },
      fullScreen(item) {
        this.$showFullScreen(item);
        this.full = true;

      },
      getResources() {
        if (!this.$store.state.currentItem.link == '') {
          this.resources.push({
            link: this.$store.state.currentItem.link
          })

        }
        for (var i = 0; i < this.$store.state.currentItem.images; i++) {
          this.resources.push({
            img: this.$store.state.currentItem.id + '-' + (i + 1) + '.jpg'
          });
        }
        console.log(this.resources)
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
     /*  this.resources = [];
      this.getList(this.activeId) */
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
     

      this.audio = false;
      var that = this;
      this.resources = [];
      this.getList(this.activeId);
      this.$audio.addEventListener('ended', function () {
        console.log("监听音频播放结束")
        that.audio = false;
        that.$store.commit('changeAudio', that.audio);
      })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less'>
  //@import url(); 引入公共css类
  .son-parent {
    width: 100%;

  }

  .son-iframe {
    width: 100%;

    height: 30.7vw;

  }

  .full-screen {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  /*   .full-btn {
    display: block;
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 30px;

    img {
      width: 100%;
    }
  } */

  .swiper-pagination-bullet-active {
    background: #d20000;
  }

  .son-swiper {
    position: relative;

    .bt-button {
      position: absolute;
      z-index: 2;
      right: 10px;
      bottom: 10px;

      span {
        display: block;
        width: 30px;
        margin-left: 5px;
      }
    }
  }
</style>